import { inject, Injectable } from '@angular/core';

import { map } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';

import type { IntelligenceSettings } from './intelligence-settings.store';

@Injectable({ providedIn: 'root' })
export class IntelligenceSettingsHttpClient {
  private readonly http = inject(HttpApiService);

  public fetch() {
    return this.http
      .get(`/intelligence/settings`)
      .pipe(map((response): IntelligenceSettings => response.companySettings));
  }

  public update(companySettings: Partial<IntelligenceSettings>) {
    return this.http
      .patch(`/intelligence/settings`, null, { companySettings })
      .pipe(map((response): IntelligenceSettings => response.companySettings));
  }
}
